import { IconsSize, IconsStyle } from '../../enums';

const IconBookmarkComponent = ({
  size,
  style,
  color,
}: {
  size: IconsSize;
  style: IconsStyle;
  color?: string;
}) => {
  return style === IconsStyle.OUTLINE ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.18657 2.03196C6.79714 2.09625 6.52265 2.18714 6.16008 2.37187C5.18306 2.86971 4.50167 3.77151 4.27257 4.86997C4.21989 5.12249 4.19488 5.44348 4.14011 6.57066C3.99192 9.61947 3.95901 13.2142 4.05224 16.1666C4.09673 17.5755 4.23332 20.3102 4.28288 20.7844C4.35362 21.4612 4.92762 21.9959 5.58794 22C5.84456 22.0016 6.15973 21.8933 6.37608 21.7292C6.42522 21.6919 7.55907 20.5953 8.89573 19.2922C10.2324 17.9891 11.3697 16.8949 11.423 16.8607C11.7646 16.6414 12.2399 16.6413 12.5813 16.8605C12.6345 16.8946 13.7727 17.9899 15.1107 19.2944C16.4488 20.5989 17.5916 21.7019 17.6504 21.7455C17.7914 21.8501 17.9469 21.9203 18.1357 21.9646C18.8842 22.1402 19.6388 21.5786 19.7218 20.7844C19.7719 20.3045 19.9082 17.5582 19.9531 16.1216C20.02 13.9849 20.0147 10.5847 19.9412 8.47409C19.9063 7.4709 19.8088 5.41478 19.7864 5.20786C19.6971 4.38549 19.3493 3.64651 18.7738 3.05665C18.2279 2.49707 17.5588 2.1515 16.7909 2.03259C16.5946 2.00218 16.0034 1.99826 11.9643 2.00054C8.33888 2.00256 7.32418 2.00923 7.18657 2.03196ZM7.36129 2.95795C7.33727 2.96293 7.26356 2.9777 7.19749 2.99079C6.43612 3.1416 5.7477 3.68566 5.38849 4.42043C5.16747 4.8725 5.13403 5.07694 5.06836 6.37834C4.84139 10.8745 4.86306 15.2546 5.13456 19.7707C5.19737 20.8156 5.20143 20.8363 5.36949 20.9739C5.43944 21.0312 5.47203 21.042 5.57697 21.0427C5.66154 21.0432 5.7269 21.029 5.78087 20.9984C5.82457 20.9736 6.9548 19.8854 8.29249 18.5802C10.0454 16.8698 10.7736 16.1735 10.8997 16.0869C11.2397 15.8536 11.5663 15.7553 12.0023 15.7553C12.4384 15.7553 12.7649 15.8535 13.1049 16.0869C13.2311 16.1736 13.9585 16.8692 15.7119 18.5802C17.0495 19.8854 18.1797 20.9736 18.2235 20.9984C18.2776 21.029 18.3432 21.0432 18.4277 21.0427C18.5326 21.042 18.5652 21.0312 18.6352 20.9739C18.8035 20.8361 18.8075 20.8157 18.8701 19.7707C19.1393 15.2735 19.161 10.8947 18.9361 6.41139C18.8682 5.05793 18.8406 4.88507 18.6178 4.41946C18.2895 3.73342 17.6853 3.23339 16.9218 3.01593L16.7089 2.95529L12.0569 2.95209C9.49835 2.95033 7.38531 2.95297 7.36129 2.95795Z"
        fill={color}
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33857 2C6.17188 2 4.3336 3.64035 4.20284 5.80501C3.91395 10.5927 3.92915 15.3924 4.27734 20.1832C4.39594 21.8265 6.39995 22.595 7.61482 21.464L12.2386 17.1556C12.3092 17.0897 12.4028 17.0529 12.5002 17.0529C12.5975 17.0529 12.6911 17.0897 12.7617 17.1556L17.3855 21.464C18.6019 22.595 20.6044 21.8265 20.723 20.1832C21.0655 15.3977 21.0904 10.5952 20.7975 5.80651C20.6652 3.64035 18.8284 2 16.6617 2H8.33857Z"
        fill={color}
      />
    </svg>
  );
};

export default IconBookmarkComponent;
